import React, { useEffect, useState,useMemo, useRef } from 'react';
import DataTable from 'components/Core/DataTable';
import Notify from 'lib/Utils/Alert';
import NotificationAlert from "react-notification-alert";
import Purchaser from "lib/Core/Backend/Controllers/Purchaser"
import PurchaseOrder from "lib/Core/Backend/Controllers/PurchaseOrder";
import Spinner from 'react-bootstrap/Spinner';
import { ModalHeader,Modal, ModalFooter,ModalBody,Button} from 'reactstrap';
import { CurrencyBitcoin } from '@mui/icons-material';



const PaymentManager = ({ token, payment,sendId,apidata,updatedData,paymentModalTwo,cancelOrder,setPaymentModalTwo,setCancelOrder,dropdownCall,setdropdownCall}) => {
  
  const alert = useRef();
  const table = React.createRef();
  const purchaserCtl = useMemo(() => new Purchaser(token), [token]);
  const purchaseOrderCtl = useMemo(() => new PurchaseOrder(token), [token]);
  const [apicalled,setApicalled] =  useState(true)
  
  const [orderNumber, setOrderNumber] = useState(null);
  const [statusNumber, setStatusNumber] = useState(null);
  const [warningModal,setWarningModal] = useState(false)
  const [buttonLoader,setButtonLoader] = useState(false);
   const togglePayment = () => {
    setPaymentModalTwo((prev) => !prev); 
  };

  const toogleCancel = () => {
    setCancelOrder((prev) => !prev); 
  };

  const toggleWarning = () => setWarningModal(!warningModal);
  const dropdownCallRef = useRef(dropdownCall);

  useEffect(() => {
    dropdownCallRef.current = dropdownCall;
  }, [dropdownCall]); 


 const tableredraw =  {
  date:updatedData.date,
  number:updatedData.number,
  reference:updatedData.reference,
  status:updatedData.status,
  value:updatedData.amount,
  currency:updatedData.currency
 }

  useEffect(() => {
    if (table.current) {
      table.current.dataTable.rows.add(payment).draw();
    }
  }, [payment]);

  useEffect(()=>{
    if(apidata){
      if(table.current){
        table.current.dataTable.row.add(tableredraw).draw();
      }
      
    }
  },[updatedData])

 const  handleStatusChange = (event) =>{
  const currentDropdownCall = dropdownCallRef.current;
if(currentDropdownCall === true){
    return;
  }else{
    const statusValue = event.target.value;
    const numericPart = statusValue.charAt(0);
    const nonNumericPart = statusValue.slice(1);
    if(numericPart == 4) {
      setOrderNumber(nonNumericPart);
      setStatusNumber(numericPart);
        
      togglePayment()
      }
  
      if(numericPart == 3){
        setOrderNumber(nonNumericPart);
        setStatusNumber(numericPart);
        toogleCancel()
      }
  }
 
}

  const confirmTransction = () =>{
    setButtonLoader(true)
    purchaserCtl.statusUpdate(sendId,orderNumber,(data) => {
      if(data?.status === 403){
        toggleWarning();
        togglePayment();
        setButtonLoader(false)
        return;
      }

      if(data && !data.error){
        Notify(alert, "success", "Transaction status updated successfully");
        setApicalled(false)
        const statusUpdated = {
          status: data.status,
        };
        setButtonLoader(false)
        setTimeout(() => {
          window.location.reload();
        }, 2000);
        togglePayment()
      }else{
      const errorCode = data.error
        if(errorCode.includes("Server error response code: 500.")){
          Notify(alert,"danger","Internal Server Error")
        }
        Notify(alert,"danger", data?.error)
        setButtonLoader(false)
        togglePayment()
      }
        
      
        
      });
    
  }

  const cancelTransaction = () =>{
    
    purchaseOrderCtl.cancelOrder(orderNumber,(data)=>{
      if(data?.status === 403){
        toggleWarning();
        toogleCancel();
        return;
      }
      
      if(data && !data.error){
        Notify(alert, 'warning', 'Transaction has been Canceled')
        
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      
      toogleCancel()
      }else{
        Notify(alert,"danger",data?.errorMessage ?? data?.error)
      }
       
    })
  }

  const handleClose = () =>{
    togglePayment()
  }

  return (
    <>
    <NotificationAlert ref={alert} />
    <div>
      
      <div className='table-responsive'>
      <DataTable
      options={{
        saveState: true,
        order: [[0, 'desc']],
        dom:"tr"
      }}
        ref={table}
        data={null}
        columns={[
          { title: 'Date', data: 'date' },
          { title: 'Number', data: 'number' },
          {title:"Reference",data:'reference'},
          {title:"Currency", data: 'currency',render:(data) =>{
            if(data){
              return `${data}`
            }else{
              return ``
            }
          }},
          { title: 'Value', data: 'value',
          render: (data) => {
            if(data){
              return `<span style="width: 100px" class=" text-dark">$${data.toFixed(2).length > 5 ? data.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") : data.toFixed(2)}</span>`;
            }else{
              return `
              `
            }
          }
        
        },
          { title: 'Status', data: 'status', 
        
          render: (data, type, row) => {
            
            
            if (data) {
             switch(data){
                case 3:
                return `<span style="width: 100px" class="badge badge-pill text-white bg-radicalRed">canceled</span>`
                case 4: 
                return `<span style="width: 100px" class="badge badge-pill text-white bg-shamrock">completed</span>`
                 case 13 :
                return `${apicalled === false ? "" :  `<select style="width: 108px; margin-top: 5px; height:36px" class="form-control" value="${data && row.number }" 
                ${onchange= (event)=> handleStatusChange(event)}>
                <option value="13${row.number} " class="badge badge-pill text-white bg-warning">Pending</option>
                <option value="4${row.number}" class="badge badge-pill text-white bg-shamrock">Completed</option>
                <option value="3${row.number}" class="badge badge-pill text-white bg-radicalRed">Canceled</option>
                
                
              </select>
            `}`
                
               
            default: return '<span style="width: 100px" class="badge badge-pill text-white bg-warning">Error</span>`'
}
              }
              
            }
          
          },

         
        
        
        
        ]}
        
      />
      </div>

      <Modal
       isOpen={paymentModalTwo}
       toggle={togglePayment}
       
       backdrop="static"
       centered
       size="md"
       style={{ maxWidth: "60% !important" }}
       
     >
      <ModalHeader  toggle={handleClose} className='custom_header_colourTwo'>
       Change Transaction
      </ModalHeader>
      <ModalBody>
        <h5 className='mx-0 auto'>Do You Want to Complete Transaction?</h5>
      </ModalBody>
      <ModalFooter className='justify-content-between'>
                        { buttonLoader ?  <Button
                          type="button"
                          color="success"
                          // onClick={(event)=>confirmTransction(event)}
                          disabled
                        >
                          <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                        </Button> : <Button
                          type="button"
                          className="btn btn-primaryTwo"
                          onClick={(event)=>confirmTransction(event)}
                        >
                          Confirm
                        </Button>}
                        <Button
                          type="submit"
                          className="btn btn-primaryTwo"
                          onClick={()=>setPaymentModalTwo(false)}
                        >
                          Cancel
                        </Button>
      </ModalFooter>

      </Modal>

      <Modal
       isOpen={cancelOrder}
       toggle={toogleCancel}
       
       backdrop="static"
       centered
       size="md"
       style={{ maxWidth: "60% !important" }}
       
     >
      <ModalHeader  toggle={toogleCancel} className='custom_header_colourTwo'>
       Change Transaction
      </ModalHeader>
      <ModalBody>
        <h5 className='mx-0 auto'>Do You Want to Cancel Transaction?</h5>
      </ModalBody>
      <ModalFooter className='justify-content-between'>
                        <Button
                          type="button"
                          className="btn btn-primaryTwo"
                          onClick={(event)=>cancelTransaction(event)}
                        >
                          Confirm
                        </Button>{" "}
                        <Button
                          type="submit"
                          className="btn btn-primaryTwo"
                          onClick={()=>setCancelOrder(false)}
                        >
                          Cancel
                        </Button>
      </ModalFooter>

      </Modal>
      <Modal isOpen={warningModal} toggle={toggleWarning} backdrop="static">
            <ModalHeader className="bg-warning" toggle={toggleWarning}>Access Denied</ModalHeader>
            <ModalBody>
                <p className="card-just-text">
				You do not have access to perform this action
                </p>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggleWarning}>Close</Button>
            </ModalFooter>
        </Modal>
    </div>
    </>
  );
};

export default PaymentManager;
